import React from 'react';

export default function LeftTimelineArrow({className}) {
	return (
		<svg className={`leftTimelineArrow ${className}`} width={15} height={22} viewBox="0 0 13 19" style={{position: 'absolute', left: 0, top: 17}}>
	        <g id="timeline-tag-triangle-outline" transform="translate(2.000000, 1.000000)">
	            <polygon strokeWidth="0" points="10.1874018 0 0 7.86396993 10.1874018 16.7682293 10.855896 16.003418 10.8118896 0.798400879"></polygon>
	            <polyline className="leftArrowStroke" strokeWidth="2" points="10.1874018 0 0 7.86396993 10.1874018 16.7682293"></polyline>
	        </g>
		</svg>
	);
}


// WEBPACK FOOTER //
// ./app/components/client-timeline/LeftTimelineArrow.js